import { render, staticRenderFns } from "./JobPurchaseInvoicesCard.vue?vue&type=template&id=0cd8a698&scoped=true&"
import script from "./JobPurchaseInvoicesCard.vue?vue&type=script&lang=js&"
export * from "./JobPurchaseInvoicesCard.vue?vue&type=script&lang=js&"
import style0 from "./JobPurchaseInvoicesCard.vue?vue&type=style&index=0&id=0cd8a698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd8a698",
  null
  
)

export default component.exports